module.exports = __webpack_public_path__ + "static/media/dashboard.e98d796b.png";